var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
var StateService = services.StateService, MediaService = services.MediaService;
export var loadStates = function (app) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var states, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'LOAD_STATES_REQUEST' });
                return [4 /*yield*/, StateService.fetchStates(app)];
            case 1:
                states = (_a.sent()).objects;
                dispatch({
                    type: 'LOAD_STATES_SUCCESS',
                    states: states,
                });
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                dispatch({
                    type: 'LOAD_STATES_FAILURE',
                    err: err_1,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var deleteState = function (app, state) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'DELETE_STATE_REQUEST' });
                    return [4 /*yield*/, StateService.deleteState(app, state)];
                case 1:
                    _a.sent();
                    dispatch({
                        type: 'DELETE_STATE_SUCCESS',
                        stateId: state,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'DELETE_STATE_FAILURE',
                        error: error_1,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var createState = function (state) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var states, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'CREATE_STATE_REQUEST' });
                return [4 /*yield*/, StateService.createState(state)];
            case 1:
                states = (_a.sent()).objects;
                dispatch({
                    type: 'CREATE_STATE_SUCCESS',
                    states: states,
                });
                return [3 /*break*/, 3];
            case 2:
                error_2 = _a.sent();
                dispatch({
                    type: 'CREATE_STATE_FAILURE',
                    error: error_2,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var updateState = function (state) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var states, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'UPDATE_STATE_REQUEST' });
                return [4 /*yield*/, StateService.updateState(state)];
            case 1:
                states = (_a.sent()).objects;
                dispatch({
                    type: 'UPDATE_STATE_SUCCESS',
                    states: states,
                });
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                dispatch({
                    type: 'UPDATE_STATE_FAILURE',
                    error: error_3,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getFiles = function (scope) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, files, meta, err_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({ type: 'STATE_LOAD_FILES_REQUEST' });
                return [4 /*yield*/, MediaService.getFiles(scope)];
            case 1:
                _a = _b.sent(), files = _a.objects, meta = _a.meta;
                dispatch({ type: 'STATE_LOAD_FILES_SUCCESS', files: files, meta: meta });
                return [3 /*break*/, 3];
            case 2:
                err_2 = _b.sent();
                dispatch({ type: 'STATE_LOAD_FILES_FAILURE', err: err_2 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
